<template>
    <div class="inc_left">
        <!--標題- 手機板-->
        <div class="Rwd_subtitle">
            {{ RWD_title }}
        </div>
        <div class="submenuall">
            <!--類別選單-->
            <div class="submubox" v-for="(item, index) in menu_list">
                <a :href="item.url" :class="(item.selected)?'submac':''">
                    <div class="subbtxxx">
                        {{ item.text }}
                    </div>
                </a>
                <div class="sublistall" v-if="item.sublist">
                    <div class="sublist" v-for="(subitem, index) in item.sublist">
                        <a :href="subitem.url" :class="(subitem.selected)?'subliac':''">
                            {{ subitem.text }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            //RWD標題
            RWD_title: "",
            //選單列表
            menu_list:[{
                text:"",
                url:"",
                selected:false,
            }]
        };
    },
    props:["sideleft"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sideleft" () {
            this.RWD_title = this.sideleft.title;
        },
        "sideleft.list"(){
           this.menu_list = this.sideleft.list;
        }
    },
    methods:{
        init(){
            this.RWD_title = this.sideleft.title;
            this.menu_list = this.sideleft.list;
        }
    }
}
</script>